import { Anchor } from "legion-ui";
import React from "react";
import * as styles from "./FeedbackSection.module.scss";

const FeedbackSection = ({toc}) => (
  <div className={`${styles["bg"]} ${styles["maxWidthFull"]}`}>
		<div className={`bx--grid bx--col-lg-12 ${styles["flex"]}` }>
			<div>
				<h3 className={styles.label}>Do you have feedback?</h3>
				<p className={styles.desc}>Please let us know to make it better</p>
			</div>
			<Anchor size="lg" className={styles.Anchor} href="https://submission.bromb.co/legion/Legion-Web" style={{marginRight:toc ? 133 : 0}}>
			Send Feedback
		</Anchor>
		</div>
  </div>
);

export default FeedbackSection;
